import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext";
import { needsOnboarding } from "./onboarding";
import type { UserType } from "./types";

export interface ProtectedRouteProps {
  allow: UserType[];
  children: ReactNode;
  /** Quando true, não força o wizard mesmo que o user precise (ex: dentro do próprio wizard). */
  bypassOnboarding?: boolean;
}

export function ProtectedRoute({ allow, children, bypassOnboarding }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // ToastProvider/RouteProgress já indica
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!allow.includes(user.tipo)) return <Navigate to="/" replace />;
  if (!bypassOnboarding && needsOnboarding(user)) return <Navigate to="/primeiro-acesso" replace />;

  return <>{children}</>;
}
